document.querySelectorAll('[data-announcement-bar-rotator]').forEach(function (rotator) {
  var slides = rotator.querySelectorAll('.announcement-bar__slide');
  if (slides.length < 2) return;

  var intervalSeconds = parseFloat(rotator.dataset.interval) || 5;
  var activeIndex = 0;
  var timer;

  function showSlide(index) {
    slides[activeIndex].classList.remove('is-active');
    activeIndex = (index + slides.length) % slides.length;
    slides[activeIndex].classList.add('is-active');
  }

  function startTimer() {
    timer = setInterval(function () {
      showSlide(activeIndex + 1);
    }, intervalSeconds * 1000);
  }

  function resetTimer() {
    clearInterval(timer);
    startTimer();
  }

  startTimer();

  var prevButton = rotator.querySelector('[data-announcement-prev]');
  var nextButton = rotator.querySelector('[data-announcement-next]');

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      showSlide(activeIndex - 1);
      resetTimer();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      showSlide(activeIndex + 1);
      resetTimer();
    });
  }
});
